import { AseLexusDetailComponent } from "../components/ase-lexus-detail/ase-lexus-detail.component";
import { CollisionRejectionReportComponent } from "../components/collision-rejection-report/collision-rejection-report.component";
import { RejectionReportComponent } from "../components/rejection-report/rejection-report.component";
import { FETCH_METHODS, SearchConfig } from "./api.model";
import { Props, TabConfig, SECTION_TYPE } from "./form.model";

export const AseLexusTitle = "ASE";

export const AseLexusProps: Props = {
  isSearchVisible: false,
  isTabStretch: false
}
export const AseLexusTabIds = {
  certificationStatus: 'Certification Status',
  rejectionReport: "Rejection Report",
  collisionRejectionReport: "Collision Rejection Report"
}
export const AseLexusDashboardTabConfig: Array<TabConfig> = [
  {
    label: 'Certification Status',
    tabId: AseLexusTabIds['certificationStatus'],
    type: SECTION_TYPE.FilterWithTable,
    component: AseLexusDetailComponent,
    inputs:{}
  },
  {
    label: 'Rejection Report',
    tabId: AseLexusTabIds['rejectionReport'],
    type: SECTION_TYPE.FilterWithTable,
    component: RejectionReportComponent,
    inputs: {}
  },
  {
    label: 'Collision Rejection Report',
    tabId: AseLexusTabIds['collisionRejectionReport'],
    type: SECTION_TYPE.FilterWithTable,
    component: CollisionRejectionReportComponent,
    inputs: {}
  }
]

export const AseDropdownSearchConfig:SearchConfig = {
  method: FETCH_METHODS['Get'],
  path: "aseDropdownOptions"
}